export const reactSelectDarkmode = (theme: string, customStyles = {}) => {
  const defaultStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '5px',
      margin: '',
      padding: '3px 7px',
      backgroundColor: state.isSelected
        ? theme === 'dark'
          ? '#6c757d'
          : 'lightgray'
        : state.isFocused
          ? theme === 'dark'
            ? '#0d5d69'
            : 'lightgray'
          : theme === 'dark'
            ? '#212529'
            : 'white',
      color: theme === 'dark' ? 'white' : 'black',
    }),
    control: (provided: any) => ({
      ...provided,
      backgroundColor: theme === 'dark' ? '#212529' : 'white',
      borderColor: theme === 'dark' ? '#6c757d' : 'gray',
      color: theme === 'dark' ? 'white' : 'black',
      minWidth: 'max-content',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme === 'dark' ? 'white' : 'black',
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: theme === 'dark' ? '#212529' : 'white',
      border: theme === 'dark' ? '1px solid gray' : 0,
      padding: '5px',
      zIndex: '10',
    }),
    input: (provided: any) => ({
      ...provided,
      color: theme === 'dark' ? 'white' : 'black',
    }),
  }

  return mergeStyles(defaultStyles, customStyles)
}

const mergeStyles = (defaultStyles: any, customStyles: any) => {
  for (const key in customStyles) {
    if (Object.hasOwnProperty.call(customStyles, key)) {
      // @ts-ignore
      const customStyle = customStyles[key]
      // @ts-ignore
      const defaultStyleFunction = defaultStyles[key]
      if (defaultStyleFunction) {
        /* @ts-ignore */
        defaultStyles[key] = (provided: any, state: any) => {
          const defaultStyle = defaultStyleFunction(provided, state)
          // Check if customStyle is a function before calling it.
          const customStyleResult =
            typeof customStyle === 'function'
              ? customStyle(provided, state)
              : customStyle
          return { ...defaultStyle, ...customStyleResult }
        }
      } else {
        /* @ts-ignore */
        defaultStyles[key] = customStyle
      }
    }
  }
  return defaultStyles
}
